import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {VehicleService} from 'services/calculator-items/vehicle.service';

@Component({
  selector: 'tpc-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.css']
})
export class VehicleListComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    public vehicleType = 'car';
    public vehicleList = [];

    constructor(private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
        this.vehicleList = this.vehicleService.getVehicleList();
    }

    next() {
        this.footerService.skip();
    }

    addVehicle() {
        this.router.navigate(['/individual/vehicle/' + this.vehicleType]);
    }

    deleteVehicle(index) {
        this.vehicleService.deleteFromVehicleList(index);
        this.vehicleList = this.vehicleService.getVehicleList();
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-list/vehicle-list.component.ts